import { useMemo } from 'react';

import { useApplicationConfig } from '@bonusly/application';
import { joinPath } from '@bonusly/http';
import { createHttpClient, useHttpClient } from '@bonusly/http-client';
import { useRecognizeURL } from '@bonusly/url';

import { useIsRecognize } from '../../../../../hooks/use-is-recognize';

const monarchApiPath = '/api/v2';

export const useNotificationsHttpClient = () => {
	const isRecognize = useIsRecognize();
	const recognizeClient = useHttpClient();
	const monarchOrigin = useApplicationConfig('monarchOrigin');
	const loginURL = useRecognizeURL('/users/sign_in_start');

	const monarchClient = useMemo(() => {
		if (isRecognize) {
			return null;
		}

		return createHttpClient(joinPath(monarchOrigin, monarchApiPath), {
			onUnauthorized: () => {
				window.location.assign(loginURL);
			},
		});
	}, [isRecognize, loginURL, monarchOrigin]);

	return monarchClient ?? recognizeClient;
};
